/**
 * @file
 * Accordion open/close behaviors for layerone. Hover, focus and open
 * looks are CSS (components/_paragraph__accordion.scss).
 */
(function ($, Drupal) {

  'use strict';

  // Take scroll restoration into our own hands: the browser would otherwise
  // restore the old scroll Y before restoreAccordionState() below has
  // re-expanded anything, landing the user in the middle of much shorter
  // (all-collapsed) content.
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function accordionStorageKey() {
    return 'layerone-accordion-state:' + window.location.pathname;
  }

  function accordionButtonKey($button, index) {
    return $button.attr('id') || $button.closest('.accordion-item').attr('id') || ('idx-' + index);
  }

  function saveAccordionState() {
    var open = {};
    $('.accordion-item button').each(function (index) {
      var $button = $(this);
      if ($button.attr('aria-expanded') === 'true') {
        open[accordionButtonKey($button, index)] = true;
      }
    });
    try {
      sessionStorage.setItem(accordionStorageKey(), JSON.stringify(open));
    } catch (e) {}
  }

  function saveScrollPosition() {
    try {
      sessionStorage.setItem('layerone-scroll-y:' + window.location.pathname, String(window.scrollY));
    } catch (e) {}
  }

  // Re-opens whichever accordions were open when the user left the page, by
  // replaying real clicks (so every class/aria change the click handler
  // makes stays in sync) with jQuery's animations switched off so it's
  // instant instead of slide-toggling each one on load.
  function restoreAccordionState() {
    var saved;
    try {
      saved = JSON.parse(sessionStorage.getItem(accordionStorageKey()) || '{}');
    } catch (e) {
      saved = {};
    }
    if (!Object.keys(saved).length) {
      restoreScrollPosition();
      return;
    }

    var wasOff = $.fx.off;
    $.fx.off = true;
    $('.accordion-item button').each(function (index) {
      var $button = $(this);
      if (saved[accordionButtonKey($button, index)] && $button.attr('aria-expanded') !== 'true') {
        $button.trigger('click');
      }
    });
    $.fx.off = wasOff;

    restoreScrollPosition();
  }

  function restoreScrollPosition() {
    var saved = sessionStorage.getItem('layerone-scroll-y:' + window.location.pathname);
    if (saved === null) {
      return;
    }
    var y = parseInt(saved, 10);
    // Run once layout has settled from the restored accordions, and again
    // after everything (including images) has finished loading, since those
    // can still shift the page height after the first pass.
    requestAnimationFrame(function () {
      window.scrollTo(0, y);
    });
    window.addEventListener('load', function () {
      window.scrollTo(0, y);
    }, { once: true });
  }

  $(window).on('pagehide', saveScrollPosition);

  // Opens or closes one item: aria-expanded on its heading's button (the
  // open styles are plain CSS on that - components/_paragraph__accordion.
  // scss), accordion-expanded / -collapsed on the heading (its corners),
  // and the content sliding open or shut.
  function setAccordionOpen($button, open) {
    var $heading = $button.parent();
    $button.attr('aria-expanded', open ? 'true' : 'false');
    $heading.toggleClass('accordion-expanded', open).toggleClass('accordion-collapsed', !open);
    // (In a Two column layout the layout grows with it: its height is the
    // columns' content, in CSS.)
    $heading.next('div')[open ? 'slideDown' : 'slideUp'](400);
  }

  Drupal.behaviors.layeroneAccordions = {
    attach: function (context, settings) {
      // Closed to begin with.
      $(once('layerone-accordion-items', '.field-accordion-items', context)).each(function () {
        $(this).find('.accordion-item').next('div').hide();
      });

      // Open all / Close all (when the group shows them): one replaces the
      // other.
      $(once('layerone-accordion-open-all', '.accordion-open-all', context)).on('click', function () {
        $(this).parents('.field-accordion-items').find('.accordion-item button[aria-expanded="false"]').each(function () {
          setAccordionOpen($(this), true);
        });
        $(this).addClass('d-none').next('button').removeClass('d-none').trigger('focus');
        saveAccordionState();
      });
      $(once('layerone-accordion-close-all', '.accordion-close-all', context)).on('click', function () {
        $(this).parents('.field-accordion-items').find('.accordion-item button[aria-expanded="true"]').each(function () {
          setAccordionOpen($(this), false);
        });
        $(this).addClass('d-none').prev('button').removeClass('d-none').trigger('focus');
        saveAccordionState();
      });

      $(once('layerone-accordion-button', '.accordion-item button', context)).on('click', function () {
        setAccordionOpen($(this), $(this).attr('aria-expanded') !== 'true');
        saveAccordionState();
      });

      // Items left open on this page earlier in the visit (once the buttons
      // above can be clicked).
      if (context === document) {
        restoreAccordionState();
      }
    }
  };
})(jQuery, Drupal);
